import cyber01 from "../assets/projects/cyber-01.jpg";
import cyber02 from "../assets/projects/cyber-02.jpg";
import cyber03 from "../assets/projects/cyber-03.jpg";
import cyber04 from "../assets/projects/cyber-04.jpg";
import cyber05 from "../assets/projects/cyber-05.jpg";
import eos01 from "../assets/projects/eos-01.jpg";
import gyal01 from "../assets/projects/gyal-01.jpg";
import gyal02 from "../assets/projects/gyal-02.jpg";
import gyal03 from "../assets/projects/gyal-03.jpg";
import gyal04 from "../assets/projects/gyal-04.jpg";
import fabfitHero from "../assets/projects/fabfit/fabfit-hero.png";
import fabfitSketches from "../assets/projects/fabfit/fabfit-sketches.png";
import fabfitLogos from "../assets/projects/fabfit/fabfit-logos.png";
import fabfitPoster from "../assets/projects/fabfit/fabfit-poster.png";
import fabfitBillboard from "../assets/projects/fabfit/fabfit-billboard.png";
import fabfitRack1 from "../assets/projects/fabfit/fabfit-rack-1.jpg";
import fabfitRack2 from "../assets/projects/fabfit/fabfit-rack-2.jpg";
import fabfitScreen1 from "../assets/projects/fabfit/fabfit-screen-1.png";
import fabfitScreen2 from "../assets/projects/fabfit/fabfit-screen-2.png";
import fabfitVideo from "../assets/projects/fabfit/fabfit-video.mov";
import twiceHero from "../assets/projects/twice/twice-hero.png";
import twiceProcess from "../assets/projects/twice/twice-process.png";
import twiceRealworld from "../assets/projects/twice/twice-realworld.png";
import twiceSocial from "../assets/projects/twice/twice-social.png";
import twiceBillboard from "../assets/projects/twice/twice-billboard.png";
import socialBare from "../assets/projects/social/social-bare.webp";
import socialJorja from "../assets/projects/social/social-jorja.png";
import socialDeegan from "../assets/projects/social/social-deegan.png";
import socialTrinity from "../assets/projects/social/social-trinity.png";
import social1 from "../assets/projects/social/social-1.png";

export const CATEGORIES = [
  { id: "all", label: "All Work" },
  { id: "photography", label: "Photography" },
  { id: "branding", label: "Branding" },
  { id: "ux-ui", label: "UX/UI" },
  { id: "social-media", label: "Social Media" },
];

export const SOCIAL_SUMMARY =
  "Here are some fun and creative approaches to branding, photography, and visual storytelling for social media. Each project explores creative ways to connect brands and people to their audience through thoughtful design, imagery, and engaging content. Everything displayed was created and designed by me with the goal of building strong visual connection and impact.";

export const SOCIAL_POSTERS = [
  { id: "social-bare", image: socialBare, alt: "Bare Cosmetics social poster" },
  { id: "social-jorja", image: socialJorja, alt: "Jorja Smith poster design" },
  { id: "social-deegan", image: socialDeegan, alt: "Deegan poster design" },
  { id: "social-trinity", image: socialTrinity, alt: "Trinity Rodman poster design" },
  { id: "social-1", image: social1, alt: "Social poster design" },
];

export const PROJECTS = [
  // ----- Photography -----
  {
    slug: "cyber-y2k-editorial",
    title: "Cyber Y2K Editorial",
    category: "photography",
    year: "2025",
    role: "Creative Direction · Photography · Post Production",
    cover: cyber04,
    images: [cyber04, cyber03, cyber02, cyber05],
    preview:
      "An editorial photoshoot exploring cyber-inspired fashion through bold lighting and experimental retouching.",
    description:
      "This editorial photoshoot explores cyber inspired fashion through bold lighting, layered composition, and experimental retouching. The visual direction blends photography with graphic elements and color manipulation to create a futuristic narrative inspired by Y2K aesthetics. My role included creative direction, photography, and post production editing. Throughout the project I experimented with multiple visual approaches including surreal miniature self concepts and vintage television inspired compositions to emphasize a nostalgic yet futuristic aesthetic.",
  },
  {
    slug: "eos-product-story",
    title: "EOS Product Story",
    category: "photography",
    year: "2025",
    role: "Creative Direction · Product Photography",
    cover: eos01,
    images: [eos01],
    preview:
      "A lifestyle product story positioning EOS as everyday essentials with a soft, relatable aesthetic.",
    description:
      "This product photoshoot was inspired by everyday essentials and the idea of self care as part of daily expression. The goal was to position EOS products as both functional and visually appealing within a lifestyle context. The creative direction focused on clean, soft, and relatable imagery that highlights texture, usability, and mood. The final visuals aim to strengthen the emotional connection between the product and its audience through an everyday lifestyle approach.",
  },
  {
    slug: "gyal-gala-collaboration",
    title: "Gyal Gala Collaboration",
    category: "photography",
    year: "2024",
    role: "Creative Direction · Photography",
    cover: gyal01,
    images: [gyal01, gyal04, gyal02, gyal03, cyber01],
    preview:
      "A collaborative spring picnic concept celebrating girlhood, color, and modern it-girl style.",
    description:
      "This collaborative photoshoot was created with Gyal Gala, a local creative group known for bold fashion and artistic expression. I led creative direction for a spring inspired picnic concept that highlighted individuality and personal style. The shoot celebrates girlhood, creativity, and confidence through color, composition, and expressive posing. The final result is a vibrant fashion story that captures a modern it girl aesthetic.",
  },

  // ----- UX/UI -----
  {
    slug: "twice-as-nice",
    title: "Twice as Nice",
    category: "ux-ui",
    year: "2025",
    role: "UX/UI Designer — Research, Wireframing, Prototyping, Visual Design",
    tools: "Adobe Illustrator · Figma · Photoshop",
    cover: twiceHero,
    preview:
      "A fashion-focused e-commerce app reimagining the online shopping experience around trust, clarity, and ease.",
    process: [
      {
        label: "Visual Design Process",
        image: twiceProcess,
        note: "From hand sketches and low-fidelity wireframes to high-fidelity flows.",
      },
      {
        label: "Real-World Displays",
        image: twiceRealworld,
        note: "Retail, social, and packaging mockups extending the brand off-screen.",
      },
    ],
    campaign: [
      { type: "image", label: "Social — In-Feed Concept", image: twiceSocial, span: "half" },
      { type: "image", label: "Out-of-Home Billboard", image: twiceBillboard, span: "half" },
    ],
    prototype: {
      embedUrl:
        "https://embed.figma.com/proto/3mfYleI4QdJ3O2QXsJxoDT/Twice-As-Nice?node-id=50-1098&starting-point-node-id=50%3A10&embed-host=share",
      label: "View Interactive Prototype",
      externalUrl:
        "https://www.figma.com/proto/3mfYleI4QdJ3O2QXsJxoDT/Twice-As-Nice?node-id=50-1098&starting-point-node-id=50%3A10",
    },
    images: [twiceHero, twiceProcess, twiceRealworld, twiceSocial, twiceBillboard],
    caseStudy: [
      {
        heading: "Project Overview",
        body: "Twice as Nice is a fashion-focused e-commerce application designed to help users upgrade their wardrobe affordably without sacrificing quality or convenience. The app was created in response to common frustrations users experience with online shopping platforms, including misleading discounts, confusing checkout systems, unreliable shipping experiences, and poor-quality products. The goal of the project is to create a trustworthy and seamless shopping experience that combines affordability, accessibility, and modern design.",
      },
      {
        heading: "The Problem",
        body: "Many e-commerce platforms advertise discounts that become unclear or unavailable during checkout, leading to frustration and abandoned carts. Users also experience issues with inaccurate shipping information, low inventory, poor-quality materials, hidden membership fees, and overly complicated rewards systems.",
      },
      {
        heading: "The Solution",
        body: "Twice as Nice simplifies the online shopping experience by automatically applying eligible coupons during checkout and clearly displaying discounts before purchase. The app also prioritizes shipping confirmation before final checkout to reduce delivery errors and additional fees. The experience was designed to feel seamless, trustworthy, and user-friendly while still offering trendy and affordable fashion options.",
      },
      {
        heading: "Research",
        body: "Research included surveys, user interviews, competitive analysis, indirect competitor analysis, desktop research, journey mapping, empathy mapping, and affinity mapping. Findings showed that users value convenience, easy navigation, and product variety, but are often frustrated by false advertising, surprise fees, inaccurate sizing, delayed shipping, and unnecessary membership costs.",
      },
      {
        heading: "Target Audience",
        body: "Young women ages 18 to 35 looking for trendy and affordable fashion while staying within budget.",
      },
      {
        heading: "Competitive Analysis",
        body: "Research focused on platforms such as Shein, Fashion Nova, and Waydamin, along with indirect competitors like Target and Chick-fil-A. This helped identify successful features and pain points related to loyalty systems, automatic discount applications, convenience, shipping expectations, customer experience, and product quality.",
      },
      {
        heading: "Design Process",
        body: "The design process included sketching, low-fidelity wireframes, and high-fidelity prototypes. The final interface focused on strong visual hierarchy, intuitive navigation, automatic coupon application, clear shipping visibility, integrated customer support, search functionality, and an improved checkout experience.",
      },
      {
        heading: "Conclusion",
        body: "Twice as Nice demonstrates how thoughtful user-centered design can improve trust and usability within e-commerce experiences. The final design focuses on accessibility, functionality, and clean visual presentation to create a more enjoyable and efficient shopping experience.",
      },
      {
        heading: "Takeaways",
        body: "This project strengthened my understanding of UX strategy, usability testing, visual hierarchy, and designing around real user frustrations. It also helped deepen my understanding of balancing aesthetics with functionality in e-commerce design.",
      },
      {
        heading: "What's Next",
        body: "Future plans for Twice as Nice include expanding into a fully responsive website, increasing accessibility for a wider audience, and eventually growing into both a global digital and physical shopping experience.",
      },
    ],
    description:
      "Twice as Nice is a fashion-focused e-commerce app designed around trust, clarity, and ease — reimagining online shopping for young women who want affordable style without the friction of misleading discounts, confusing checkouts, and unreliable shipping.",
  },

  // ----- Branding -----
  {
    slug: "nike-x-bratz-fab-fit",
    title: "Nike × Bratz — Fab & Fit",
    category: "branding",
    year: "2025",
    role: "Creative Direction · Brand Identity · Campaign Design",
    cover: fabfitRack1,
    layout: "split",
    preview:
      "A fictional Nike × Bratz collaboration imagining a limited edition campaign for fashion, fitness, and femininity.",
    process: [
      {
        label: "",
        image: fabfitSketches,
      },
      {
        label: "",
        image: fabfitLogos,
      },
    ],
    campaign: [
      { type: "image", label: "", image: fabfitHero, span: "full" },
      { type: "video", label: "", src: fabfitVideo, span: "half" },
      { type: "image", label: "", image: fabfitRack2, span: "half" },
      { type: "image", label: "", image: fabfitPoster, span: "full" },
      { type: "image", label: "", image: fabfitBillboard, span: "full" },
      { type: "image", label: "", image: fabfitScreen1, span: "half" },
      { type: "image", label: "", image: fabfitScreen2, span: "half" },
    ],
    images: [
      fabfitRack1,
      fabfitSketches,
      fabfitLogos,
      fabfitHero,
      fabfitRack2,
      fabfitPoster,
      fabfitBillboard,
      fabfitScreen1,
      fabfitScreen2,
    ],
    description:
      "For this project, I created a collaboration logo and ad series for a fictional partnership between Nike and Bratz. Growing up, I was always inspired by both brands, so combining beauty, fashion, and athletics felt like a natural way to merge two creative influences that shaped my interests.\n\nThe goal of this project was to create something nostalgic for young women today while also connecting with older Gen Z and millennial audiences who grew up with Bratz dolls. I wanted to preserve the bold and playful identity associated with Bratz while giving it a more elevated and fashion forward visual direction.\n\nThe project imagines a limited edition Nike and Bratz collaboration featuring apparel, branding, and advertising concepts. Throughout the campaign, I explored different ways to combine Nike's athletic identity with the signature glamour and attitude of Bratz. One advertisement features Bratz inspired characters running on a track, blending sporty energy with stylized fashion visuals. Another concept references the iconic digital closet scene from Clueless and reimagines it through a Bratz inspired lens to emphasize the fashion side of the collaboration.\n\nThis project gave me the opportunity to step outside of my comfort zone creatively and experiment with a more playful and imaginative approach to branding. With wellness, fitness, and self expression becoming increasingly important to young women today, I wanted to create a concept that felt both nostalgic and culturally relevant. The final result combines femininity, fashion, fitness, and branding in a way that feels personal to me while still functioning as a cohesive campaign concept.",
  },
];

export const getProjectsByCategory = (categoryId) => {
  if (!categoryId || categoryId === "all") return PROJECTS;
  return PROJECTS.filter((p) => p.category === categoryId);
};

export const getProjectBySlug = (slug) => PROJECTS.find((p) => p.slug === slug);
